  import React, { useState, useEffect } from 'react';
  import {loadingStyles, readMoreButtonStyles, pageHeaderSubStyles, pageHeaderTitleStyles, pageHeaderStyles, sectionStyles, containerStyles} from './styles';

  const articlesGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem', marginBottom: '3rem' };
  const articleCardStyles = { backgroundColor: 'white', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', transition: 'transform 0.3s ease' };
  const articleImageStyles = { width: '100%', height: '200px', objectFit: 'cover' };
  const articleContentStyles = { padding: '2rem' };
  const categoryBadgeStyles = { backgroundColor: '#C41E3A', color: 'white', padding: '0.3rem 0.8rem', borderRadius: '15px', fontSize: '0.85rem', fontWeight: '600' };
  const articleTitleStyles = { fontSize: '1.3rem', fontWeight: '700', margin: '1rem 0', color: '#333' };
  const articleExcerptStyles = { color: '#666', lineHeight: '1.6', marginBottom: '1.5rem' };
  const articleMetaStyles = { display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#999' };

  const ArticlesPage = ({showNotification}) => {
    const API_BASE = '/api';

    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);

    const fetchArticles = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/articles`);
            const data = await response.json();
            setArticles(data);
        } catch (error) {
            console.error('Error fetching articles:', error);
            showNotification('Error loading articles', 'error');
        } finally {
            setLoading(false);
        }
    };

        // Load data when component mounts
        useEffect(() => {
            fetchArticles();
        }, []);
    
    if (selectedArticle) {

            return (
                      <div>
                      <section style={pageHeaderStyles}>
                          <div style={containerStyles}>
                          <h1 style={pageHeaderTitleStyles}>{selectedArticle.title}</h1>
                          <p style={pageHeaderSubStyles}>{selectedArticle.category}</p>
                          </div>
                      </section>

                      <section style={sectionStyles}>
                          <div style={containerStyles}>
                          <img 
                              src={selectedArticle.image_url || 'https://via.placeholder.com/800x400'} 
                              alt={selectedArticle.title} 
                              style={{ width: '100%', borderRadius: '10px', marginBottom: '2rem' }} 
                          />
                          <div style={{ color: '#444', lineHeight: '1.8', fontSize: '1.1rem' }}>
                              <p><strong>By:</strong> {selectedArticle.author}</p>
                              <p><strong>Date:</strong> {new Date(selectedArticle.created_at).toLocaleDateString()}</p>
                              <div dangerouslySetInnerHTML={{ __html: selectedArticle.content }} />
                          </div>
                          <button 
                              className="btn" 
                              style={{ ...readMoreButtonStyles, marginTop: '2rem' }} 
                              onClick={() => setSelectedArticle(null)}
                          >
                              ← Back to Articles
                          </button>
                          </div>
                      </section>
                      </div>
                  );
    }

    return (
          <div>
            <section style={pageHeaderStyles}>
              <div style={containerStyles}>
                <h1 style={pageHeaderTitleStyles}>Articles & Insights</h1>
                <p style={pageHeaderSubStyles}>
                  Stay informed with the latest trends, opportunities, and insights in Saudi-British business relations
                </p>
              </div>
            </section>

            <section style={sectionStyles}>
              <div style={containerStyles}>
                {loading ? (
                  <div style={loadingStyles}>Loading articles...</div>
                ) : (
                  <div style={articlesGridStyles}>
                    {articles.map(article => (
                      <div key={article.id} style={articleCardStyles}>
                        <img 
                          src={article.image_url || 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'} 
                          alt={article.title} 
                          style={articleImageStyles} 
                        />
                        <div style={articleContentStyles}>
                          <span style={categoryBadgeStyles}>{article.category}</span>
                          <h3 style={articleTitleStyles}>{article.title}</h3>
                          <p style={articleExcerptStyles}>{article.excerpt}</p>
                          <div style={articleMetaStyles}>
                            <span>{article.author}</span>
                            <span>{new Date(article.created_at).toLocaleDateString()}</span>
                          </div>
                          <button 
                              onClick={() => setSelectedArticle(article)}
                          style={readMoreButtonStyles}>Read More</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </section>
          </div>
  );
}
export default ArticlesPage;